<style lang="less">
@import '@/components/ai/zzl/zzl-ai-workbench.less';
</style>
<template>
  <div class="zzl-view-page" style="height:100%;overflow:hidden;display:flex;flex-direction:column;min-height:0;">
    <div class="flex-wrap flex-between" style="height:50px;padding:0 10px;background:linear-gradient(to right,#fff,var(--border));">
      <div class="flex-wrap split5">
        <Select v-model="project_id" filterable style="width:300px" placeholder="选择项目" @on-change="getProjectData()">
          <Option
            v-for="pr in projects"
            :key="pr.id"
            :value="pr.id"
            :label="pr.name"
          >
            {{ pr.name }}
            <Tag>{{ pr.finished ? '已完成' : '进行中' }}</Tag>
            <Tag>{{ pr.group }}</Tag>
          </Option>
        </Select>
        <Select v-model="view" style="width:140px" placeholder="选择视图" @on-change="getProjectData()">
          <Option v-for="p in views" :value="p.key" :key="p.key">{{ p.name }}</Option>
        </Select>
        <Select v-model="task_id" style="width:340px" placeholder="选择任务" filterable @on-change="getTaskData" clearable>
          <Option v-for="p in tasks" :key="p.nID" :name="p.node" :value="p.nID">{{ p.node }}</Option>
        </Select>
      </div>
      <div class="zzl-view-top-actions flex-wrap">
        <Button
          class="zzl-view-top-refresh"
          type="default"
          :disabled="!project_id"
          :loading="dataLoading"
          @click="getProjectData"
        >刷新列表</Button>
      </div>
    </div>

    <div class="zzl-view-split" style="flex:1;min-height:0;">
      <div class="zzl-view-left" style="padding:12px;display:flex;flex-direction:column;min-height:0;">
        <Spin v-if="dataLoading" fix size="large">
          <div class="zzl-view-data-loading-text">加载数据中…</div>
        </Spin>
        <div class="zzl-view-left-half zzl-view-left-half--data">
          <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:8px;flex-shrink:0;">
            <div class="zzl-view-section-title" style="margin:0;">数据下载和清理</div>
            <div class="flex-wrap" style="align-items:center;gap:8px;">
              <Button type="primary" icon="md-download" :disabled="!task_id || dataLoading" :loading="dataLoading" @click="getTaskData">获取任务数据</Button>
              <Button type="warning" @click="CopyToClip">复制数据</Button>
              <Button type="default" icon="md-download" :disabled="!aiText" @click="downloadDataFile">下载数据文件</Button>
            </div>
          </div>
          <div class="zzl-view-left-toolbar" style="margin-bottom:8px;flex-shrink:0;">
            <div class="flex-wrap" style="align-items:center;flex-wrap:wrap;gap:8px;">
              <i-switch v-model="extractForm" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">提取表格</span>
              <i-switch v-model="onlyQuestion" size="small" @on-change="cleanData" />
              <span style="font-size:12px;">隐藏合规项</span>
              <span style="font-size:12px;color:var(--subtext2);">字符数 {{ aiText.length }}</span>
            </div>
          </div>
          <div class="zzl-view-left-track flex-wrap split5" style="margin-bottom:8px;align-items:center;flex-wrap:wrap;gap:8px;flex-shrink:0;">
            <span style="font-size:12px;color:#64748b;">跟踪记录</span>
            <BaseDate v-model="tracking_startDate" placeholder="开始日期" />
            <BaseDate v-model="tracking_endDate" placeholder="结束日期" />
            <Button size="small" @click="cleanData">按跟踪刷新</Button>
          </div>
          <div class="zzl-view-left-textarea-wrap">
            <Input
              type="textarea"
              v-model="aiText"
              :rows="4"
              style="width:100%;flex:1;min-height:0;"
              placeholder="先获取任务数据后，清洗结果将显示在此。"
            />
          </div>
        </div>
        <div class="zzl-view-left-half zzl-view-left-half--prompt">
          <div class="zzl-view-left-prompt-body">
            <AiPromptPanel
              v-model="userText"
              mod="zzl-task"
              :textarea-rows="4"
              :hide-mod-hint="true"
              split-head
            >
              <template slot="head-left">
                <div class="zzl-view-section-title flex-wrap" style="margin:0;align-items:baseline;gap:8px;">
                  提示词
                  <span style="font-size:12px;font-weight:400;color:var(--subtext2);">
                    （{{ labelForMod('zzl-task') }} · zzl-task）
                  </span>
                </div>
              </template>
            </AiPromptPanel>
          </div>
        </div>
      </div>

      <div class="zzl-view-right" style="padding:10px;display:flex;flex-direction:column;min-height:0;">
        <div class="flex-wrap flex-between" style="align-items:center;margin-bottom:6px;">
          <div class="zzl-view-section-title" style="margin:0;">报告</div>
          <div class="zzl-view-right-actions flex-wrap" style="gap:8px;justify-content:flex-end;margin-left:auto;">
            <Button type="primary" icon="md-play" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateByAI">
              {{ ai_executings ? '生成中…' : (result && !resultIsHtml ? '重新生成' : '生成报告') }}
            </Button>
            <Button type="success" icon="md-code-working" :loading="ai_executings" :disabled="aiText.length < 10" @click="CreateHtmlByAI">
              {{ ai_executings ? '生成中…' : (resultIsHtml ? '重新生成 HTML' : '生成 HTML') }}
            </Button>
            <template v-if="!resultIsHtml">
              <Button v-if="images.length" @click="copyImageAddresses">复制图片地址</Button>
              <Button @click="copyReportMd" :disabled="!result">复制 Markdown</Button>
              <Button @click="exportPDF" :disabled="!result">导出 PDF</Button>
              <AiSaveToKnowledgeButton :content="result" :disabled="!result || ai_executings" :file-name="zzlSaveFileName" />
            </template>
            <AiPublishMiniappButton
              v-else
              :content="result"
              :disabled="!result || ai_executings"
              :default-name="zzlSaveFileName"
            />
          </div>
        </div>
        <div class="zzl-view-right-report">
          <AiMarkdownStreamPanel
            ref="reportPanel"
            class="pdf-export"
            style="flex:1;min-height:0;"
            :value="result"
            :streaming="ai_executings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
moment.locale('zh-cn');
import {deepCleanTask, renderEFormMap, extractAttachments} from '@/components/ai/clean';
import mixinPageState from '@/mixins/page_state';
import zzlAiStreamReport from '@/components/ai/zzl/mixins/zzlAiStreamReport';
import AiPromptPanel from '@/components/ai/AiPromptPanel.vue';
import AiMarkdownStreamPanel from '@/components/ai/AiMarkdownStreamPanel.vue';
import {labelForMod} from '@/components/ai/aiPromptModLabels';
import { buildZzlPdfFileStem } from '@/components/ai/zzl/zzl-report-filename';

export default {
  components: {AiPromptPanel, AiMarkdownStreamPanel},
  mixins: [mixinPageState, zzlAiStreamReport],
  data() {
    return {
      pageStateKey: 'ai_task',
      pageStateFields: ['project_id', 'task_id', 'onlyQuestion', 'extractForm', 'tracking_startDate', 'tracking_endDate', 'userText', 'view'],
      models: [],
      aiText: '',
      model: 'douyin',
      task: {},
      images: [],
      onlyQuestion: false,
      extractForm: false,
      files: [],
      userText: '，请从监理服务质量检查和风险管控角度，严格结合以下任务数据执行全维度分析，不关联上下文数据。分五部分内容，一是任务执行总体概况（严格统计工作模块下工作任务的数量、工作任务的状态、工作跟踪记录的数量、其中工作表单的数量）；二是评估整体监理服务质量（评估工作任务是否覆盖该工作模块规范规定的主要监理工作，验证问题发现能力，提取所有\'不符合\',\'否\',\'不合格\'等质量问题（须有影像照片记录），验证每个问题是否闭环（需有对应回复内容），计算整改时效（问题发现→问题回复时长））；三是如有潜在风险请给出分析和评价（重点对问题发现数量，问题整改回复情况，记录中“/”代表本次检查无该项）；四是对工作跟踪记录执行人进行工作量统计（ 严格统计[]内的人即为工作跟踪记录执行人）。五是从项目部监理服务质量和风险管控程度对项目部进行评价，分为优秀、良好、合格、不合格',
      tracking_startDate: null,
      tracking_endDate: null,
      ai_executings: false,
      dataLoading: false,
      result: '',
      cleaned: '',
      tasks: [],
      task_id: '',
      projects: [],
      project_id: 'pid65054f01eabec',
      view: 'yestoday',
      views: [
        {key: 'all', name: '全部工作'},
        {key: 'finished', name: '已完工作'},
        {key: 'allToDo', name: '未完工作'},
        {key: 'recent', name: '近期工作'},
        {key: 'myTodo', name: '我的待办'},
        {key: 'today', name: '今日动态'},
        {key: 'yestoday', name: '昨日动态'},
        {key: 'theDayBeforeYestoday', name: '前日动态'},
        {key: 'aboutMe', name: '我的工作'},
        {key: 'alert', name: '预警工作'},
        {key: 'nonActivation', name: '尚未启动'},
      ],
    };
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.getProjects();
      this.getProjectData();
      this.getModels();
    });
  },
  methods: {
    labelForMod,
    zzlReportPdfStem() {
      const project = this.projects.find((p) => p.id === this.project_id);
      return buildZzlPdfFileStem(['任务数据', project && project.name, this.view]);
    },
    getModels() {
      this.$api.get('ai/parse/models').then((res) => {
        this.models = res.data.data;
      });
    },
    getProjects() {
      this.$api.get('logined_zzl/projects').then((res) => {
        this.projects = res.data.data;
      });
    },
    getProjectData() {
      if (!this.project_id) {
        return;
      }
      this.dataLoading = true;
      this.$api.get(`logined_zzl/tasks?view=${this.view}&pid=${this.project_id}`).then((res) => {
        this.tasks = res.data.data || [];
      }).catch((e) => {
        console.error(e);
        this.Error(e && e.message ? e.message : '获取任务列表失败');
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    getTaskData() {
      if (!this.task_id) {
        return;
      }
      this.dataLoading = true;
      this.$api.post('logined_zzl/get_task_data', {id: this.task_id}).then((res) => {
        this.task = res.data.data;
        this.cleanData();
      }).catch((e) => {
        console.error(e);
        this.Error(e && e.message ? e.message : '获取任务数据失败');
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    cleanData() {
      this.__savePageState();
      const eformmap = {};
      this.cleaned = deepCleanTask(this.task, this.tracking_startDate, this.tracking_endDate, null, this.extractForm ? eformmap : null, this.onlyQuestion);
      const formstr = renderEFormMap(eformmap);
      this.aiText = `${this.extractForm && formstr ? ('#因存在相同的表单，对相同表单进行提取。后续数据按照key展示。\n' + formstr + '\n') : ''}# 以下是任务数据:\n` + this.cleaned;
      const {images, files, text} = extractAttachments(this.aiText);
      this.images = images;
      this.files = files;
      this.aiText = text;
    },
    async CopyToClip() {
      const text = this.aiText || '';
      try {
        if (navigator.clipboard) {
          await navigator.clipboard.writeText(text);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          if (!document.execCommand('copy')) {
            throw new Error('copy failed');
          }
          document.body.removeChild(textarea);
        }
        this.Success('复制成功');
      } catch (err) {
        console.error(err);
        this.Error('复制失败');
      }
    },
  },
};
</script>
